// Bootstrap components

import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';

import 'fslightbox';

// Theme
import './frontend/dropdown';
import './frontend/forms';
import './frontend/header';
import './frontend/url-handler';
import './frontend/modal';